import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  ReactiveFormsModule,
  FormControl,
  FormGroup,
  FormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedValidationMessageComponent } from 'src/app/common/shared-validation-message/shared-validation-message.component';
import { SharedValidationService } from 'src/app/common/shared-validation.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import {
  HttpClient,
  HttpClientModule,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { DataService } from '../expense/receipt/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserStateService } from '../expense/receipt/detail/userState.service';
import {
  Observable,
  catchError,
  debounceTime,
  forkJoin,
  map,
  of,
  startWith,
  switchMap,
  tap,
} from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-assignbill',
  standalone: true,
  imports: [
    CommonModule,
    SharedValidationMessageComponent,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    HttpClientModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatAutocompleteModule,
    FormsModule,
  ],
  templateUrl: './assignbill.component.html',
  styleUrls: ['./assignbill.component.css'],
})
export class AssignbillComponent {
  mainForm!: FormGroup;
  loading = false;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  bills: any[] = [];
  filteredBills: any[] = [];
  selectedBill: any = '';
  bill_id: string = '';
  bill_etag: string = '';
  constructor(
    private fb: FormBuilder,
    private _httpClient: HttpClient,
    private _snackBar: MatSnackBar,
    private ds: DataService,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<AssignbillComponent>,
    private router: Router,
    private userStateService: UserStateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  async ngOnInit(): Promise<void> {
    console.debug('assignData:', this.data.trip_id);
    this.mainForm = this.fb.group({
      trip_id: ['', Validators.required],
    });
    await this.loadBills();
    this.filteredBills = [...this.bills];
  }
  onSubmit() {
    if(this.bills.find(x=>x.name===this.selectedBill)){
      const tripAssign = {
        trip_id: this.data.trip_id,
      };
      this.ds.updateBillTrip(this.bill_id,tripAssign,this.bill_etag).subscribe(
        (res)=>{
          if (
            res &&
            res._status &&
            String(res._status).toLowerCase() === 'ok' &&
            res._success &&
            res._success.message
          ) {
            this._snackBar.open(
              'Successfully Bill Assigned.'
            );
          } else {
            this._snackBar.open(
              'Successfully Bill Assigned.'
            );
          }
        },
        (error:HttpErrorResponse)=>{
          console.debug(error.message)
          this._snackBar.open(
            'Error:::' +error.message
          );
        }
      )
        
    }
    else{
      this._snackBar.open(
        "Error: Bill's and Trip's Organization should be match!!"
      );
    }
  this.dialogRef.close();
  }

  filterBill(event: any): void {
    const value = event.target.value;
    if (!value) {
      this.filteredBills = [...this.bills];
    } else {
      this.filteredBills = this.bills.filter((bill) =>
        bill.name.toLowerCase().includes(value.toLowerCase())
      );
    }
  }

  onBillSelected(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedBill) console.debug('onSelect');
    console.debug(this.selectedBill);
    console.debug(event);
    const selectedBill = this.bills.find(
      (bill) => bill.name === event.option.value
    );
    if (selectedBill) {
      console.debug(selectedBill);
      if (selectedBill.trip_id === undefined) {
        this.bill_id = selectedBill._id;
        this.bill_etag = selectedBill._etag;
        this.selectedBill = selectedBill.name;
      } else {
        this._snackBar.open(
          'Bill:' +
            selectedBill.name +
            ' already assigned to a trip:' +
            selectedBill.trip_id.trip_name,
          'OK',
          {
            duration: 2000,
          }
        );
        this.selectedBill = '';
      }
    }
  }

  handleAddUserError(error: any) {
    if (
      error.status === 422 &&
      error.error?._error?.code === 422 &&
      error.error?._error?.message === 'role already exist'
    ) {
      this._snackBar.open(
        'Role already exists. Please choose a different role.',
        'Close',
        {
          duration: 5000,
        }
      );
    } else {
      console.error('Error adding user:', error);
      this._snackBar.open(error.error?._error?.message, 'Close', {
        duration: 5000,
      });
    }
  }

  getUserIdFromLocal(): string {
    var storedResponse = localStorage.getItem('LoginResponse');
    if (storedResponse !== null) {
      var parsedResponse = JSON.parse(storedResponse);
      var userId = parsedResponse._items[0].user_id;
      console.debug(userId + ' localtorage');
      return userId;
    } else {
      console.error('Stored response is null');
      return '';
    }
  }
  loadBills(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.ds.getUserBills(this.getUserIdFromLocal(),this.data.org_id).subscribe(
        (response: any) => {
          console.debug('bills::', response._items);
          this.bills = response._items;
          resolve();
        },
        (error) => {
          console.error('Error fetching users:', error);
          reject(error);
        }
      );
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
